import { Routes, Route, useLocation } from 'react-router-dom';
import Landing from './pages/Landing';
import PastQuests from './pages/PastQuests';
import Quests from './pages/Quests';
import Submit from './pages/Submit';
import Leaderboard from './pages/Leaderboard';
import Donate from './pages/Donate';
import Donors from './pages/Donors';
import TimelinePreview from './pages/TimelinePreview';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';

// Note: /admin is NOT served by this site. The admin panel is a separate
// Cloudflare Worker (kquest-admin) protected by password + TOTP, accessible only
// from a dedicated URL. This file is intentionally not aware of it.

export default function App() {
  const location = useLocation();
  // /preview/* routes are embedded in iframes by the admin panel —
  // strip the navbar/footer chrome so the preview matches what the
  // public page would actually look like.
  const isPreview = location.pathname.startsWith('/preview/');

  return (
    <div className="min-h-screen flex flex-col">
      {!isPreview && <Navbar />}
      <main className="flex-1">
        <Routes>
          <Route path="/"                  element={<Landing />} />
          <Route path="/quests"            element={<Quests />} />
          <Route path="/submit"            element={<Submit />} />
          <Route path="/leaderboard"       element={<Leaderboard />} />
          <Route path="/past"              element={<PastQuests />} />
          <Route path="/donate"            element={<Donate />} />
          <Route path="/donors"            element={<Donors />} />
          <Route path="/preview/timeline"  element={<TimelinePreview />} />
        </Routes>
      </main>
      {!isPreview && <Footer />}
    </div>
  );
}
